
import {productValues} from "../constants";

export class CurrentSystemService {
	currentSystem = null;
	pv = null;

	constructor() {
	}

	/**
	 * update current system and get default product values
	 * @param system
	 */
	updateCurrentSystem(system: string) {
		this.currentSystem = system;
		this.pv = productValues[this.currentSystem];
		console.log('UPDATED SYSTEM TO: ', system);
		console.log(this.pv);
	}

	/**
	 * get current product values
	 */
	getCurrentPvs() {
		return this.pv;
	}

	/**
	 * get current system
	 */
	getCurrentSystem(){
		return this.currentSystem;
	}
}